<template>
  <div class="p-2 rounded-xl min-h-screen">
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-4 shadow-sm border border-gray-100">
      <h2 class="text-sm font-bold text-gray-700 mb-1">بنر و اسلایدر صفحه اصلی</h2>
      <p class="text-xs text-gray-500">
        هر اسلات یک بخش بنری از صفحه اصلی سایت است. برای هر اسلات می‌توانید یک یا چند اسلاید (تصویر + لینک) تعریف کنید.
        برای تصویر می‌توانید فایل آپلود کنید یا مستقیم آدرس تصویر را وارد کنید. با فیلد «ترتیب» می‌توانید ترتیب نمایش اسلایدها را مشخص کنید.
      </p>
    </div>

    <div
        v-for="slot in slots"
        :key="slot.value"
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 mb-4 p-3"
    >
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-xs font-bold text-gray-700">{{ slot.label }}</h3>
        <button
            v-if="!contentBySlot(slot.value)"
            @click="createSlotContent(slot.value)"
            class="px-3 py-1.5 bg-gray-800 text-white text-xs rounded-lg"
        >ایجاد بنر برای این اسلات</button>
      </div>

      <template v-if="contentBySlot(slot.value)">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mb-3">
          <input
              v-model="contentBySlot(slot.value).title"
              placeholder="عنوان (اختیاری)"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
          >
          <input
              type="datetime-local"
              v-model="contentBySlot(slot.value).from_date_time"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
              title="شروع نمایش"
          >
          <input
              type="datetime-local"
              v-model="contentBySlot(slot.value).to_date_time"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
              title="پایان نمایش"
          >
          <div class="flex gap-2">
            <button
                @click="saveSlotContent(slot.value)"
                class="px-3 py-1.5 bg-emerald-600 text-white text-xs rounded-lg flex-1"
            >ذخیره</button>
            <button
                @click="deleteSlotContent(slot.value)"
                class="px-3 py-1.5 bg-red-500 text-white text-xs rounded-lg"
            >حذف اسلات</button>
          </div>
        </div>

        <div class="flex flex-wrap gap-3 mb-3">
          <div
              v-for="item in contentBySlot(slot.value).items"
              :key="item.id"
              class="w-56 border rounded-lg overflow-hidden relative"
          >
            <img :src="resolveImageUrl(item.desktop_image_url)" class="w-full h-20 object-cover">
            <div class="p-2 space-y-1">
              <input
                  v-model="item.link"
                  placeholder="لینک مقصد"
                  class="w-full px-1 py-0.5 bg-gray-100 text-[11px] rounded border"
              >
              <input
                  v-model="item.desktop_image_external"
                  placeholder="آدرس تصویر دسکتاپ"
                  class="w-full px-1 py-0.5 bg-gray-100 text-[11px] rounded border"
              >
              <input
                  v-model="item.mobile_image_external"
                  placeholder="آدرس تصویر موبایل"
                  class="w-full px-1 py-0.5 bg-gray-100 text-[11px] rounded border"
              >
              <div class="flex items-center gap-1">
                <input
                    type="number"
                    v-model.number="item.sort_order"
                    class="w-14 px-1 py-0.5 bg-gray-100 text-[11px] rounded border"
                    title="ترتیب نمایش"
                >
                <span class="text-[10px] text-gray-400">ترتیب</span>
                <button
                    @click="saveItem(item)"
                    class="mr-auto px-2 py-0.5 bg-emerald-600 text-white text-[11px] rounded"
                >ذخیره</button>
              </div>
            </div>
            <button
                @click="deleteItem(slot.value, item)"
                class="absolute top-1 left-1 bg-red-500 text-white rounded-full w-5 h-5 text-[10px]"
            >×</button>
          </div>
        </div>

        <div class="border-t pt-3">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2 mb-2">
            <div>
              <label class="block text-[11px] text-gray-500 mb-1">تصویر دسکتاپ (فایل)</label>
              <input type="file" accept="image/*" @change="onFile(slot.value, 'desktop', $event)">
            </div>
            <input
                v-model="newItemForms[slot.value].desktopUrl"
                placeholder="یا آدرس تصویر دسکتاپ"
                class="self-end px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            >
            <div>
              <label class="block text-[11px] text-gray-500 mb-1">تصویر موبایل (فایل)</label>
              <input type="file" accept="image/*" @change="onFile(slot.value, 'mobile', $event)">
            </div>
            <input
                v-model="newItemForms[slot.value].mobileUrl"
                placeholder="یا آدرس تصویر موبایل"
                class="self-end px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            >
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-2 items-end">
            <input
                v-model="newItemForms[slot.value].link"
                placeholder="لینک مقصد"
                class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            >
            <input
                type="number"
                v-model.number="newItemForms[slot.value].sortOrder"
                placeholder="ترتیب (اختیاری)"
                class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full"
            >
            <button
                @click="addItem(slot.value)"
                :disabled="addingSlot === slot.value"
                class="px-3 py-1.5 bg-gray-800 text-white text-xs rounded-lg"
            >افزودن اسلاید</button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerManagement",
  data() {
    return {
      slots: [
        { value: 1, label: "بنر اصلی" },
        { value: 2, label: "بنر دو" },
        { value: 3, label: "بنر سه" },
        { value: 4, label: "بنر چهار" },
        { value: 5, label: "بنر پنج" },
        { value: 6, label: "بنر شش" },
      ],
      bannerContents: [],
      newItemForms: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {} },
      addingSlot: null,
    };
  },
  created() {
    this.setDocumentTitle && this.setDocumentTitle("بنر و اسلایدر");
    this.fetchBannerContents();
    this.slots.forEach((s) => this.resetItemForm(s.value));
  },
  methods: {
    resetItemForm(slot) {
      this.$set(this.newItemForms, slot, {
        link: "",
        desktopFile: null,
        mobileFile: null,
        desktopUrl: "",
        mobileUrl: "",
        sortOrder: 0,
      });
    },
    contentBySlot(slot) {
      return this.bannerContents.find((c) => c.order === slot) || null;
    },
    resolveImageUrl(url) {
      if (!url) return "";
      if (/^https?:\/\//.test(url)) return url;
      return this.img_source(url);
    },
    fetchBannerContents() {
      this.request({
        url: this.endpoint("cms/bannerContent"),
        method: "get",
        success: (data) => {
          this.bannerContents = (data || []).map((c) => ({
            ...c,
            from_date_time: c.from_date_time ? c.from_date_time.slice(0, 16) : "",
            to_date_time: c.to_date_time ? c.to_date_time.slice(0, 16) : "",
          }));
        },
      });
    },
    createSlotContent(slot) {
      this.request({
        url: this.endpoint("cms/bannerContent"),
        method: "post",
        data: { order: slot, title: "" },
        success: () => {
          this.fetchBannerContents();
        },
        error: () => {
          this.notify && this.notify("خطا در ایجاد اسلات بنر", "danger");
        },
      });
    },
    saveSlotContent(slot) {
      const content = this.contentBySlot(slot);
      if (!content) return;
      this.request({
        url: this.endpoint(`cms/bannerContent/${content.id}`),
        method: "put",
        data: {
          order: content.order,
          title: content.title,
          from_date_time: content.from_date_time || null,
          to_date_time: content.to_date_time || null,
        },
        success: () => {
          this.notify && this.notify("ذخیره شد", "success");
          this.fetchBannerContents();
        },
        error: () => {
          this.notify && this.notify("خطا در ذخیره‌سازی", "danger");
        },
      });
    },
    deleteSlotContent(slot) {
      const content = this.contentBySlot(slot);
      if (!content) return;
      this.request({
        url: this.endpoint(`cms/bannerContent/${content.id}`),
        method: "delete",
        success: () => {
          this.fetchBannerContents();
        },
      });
    },
    async onFile(slot, kind, event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const maxWidth = kind === "desktop" ? 1600 : 800;
      const compressed = await this.compressImage(file, maxWidth);
      if (kind === "desktop") this.newItemForms[slot].desktopFile = compressed;
      else this.newItemForms[slot].mobileFile = compressed;
    },
    compressImage(file, maxWidth, quality = 0.8) {
      if (!file.type || !file.type.startsWith("image/")) return Promise.resolve(file);

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            const scale = Math.min(1, maxWidth / img.width);
            const canvas = document.createElement("canvas");
            canvas.width = Math.round(img.width * scale);
            canvas.height = Math.round(img.height * scale);
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(
                (blob) => {
                  if (!blob || blob.size >= file.size) {
                    resolve(file);
                    return;
                  }
                  const newName = file.name.replace(/\.[^.]+$/, "") + ".jpg";
                  resolve(new File([blob], newName, { type: "image/jpeg" }));
                },
                "image/jpeg",
                quality
            );
          };
          img.onerror = () => resolve(file);
          img.src = reader.result;
        };
        reader.onerror = () => resolve(file);
        reader.readAsDataURL(file);
      });
    },
    saveItem(item) {
      this.request({
        url: this.endpoint(`cms/bannerContentItem/${item.id}`),
        method: "put",
        data: {
          link: item.link,
          sort_order: item.sort_order,
          desktop_image_external: item.desktop_image_external || "",
          mobile_image_external: item.mobile_image_external || "",
        },
        success: () => {
          this.notify && this.notify("ذخیره شد", "success");
          this.fetchBannerContents();
        },
        error: () => {
          this.notify && this.notify("خطا در ذخیره اسلاید", "danger");
        },
      });
    },
    addItem(slot) {
      const content = this.contentBySlot(slot);
      const form = this.newItemForms[slot];
      const hasDesktop = !!(form.desktopFile || form.desktopUrl);
      const hasMobile = !!(form.mobileFile || form.mobileUrl);
      if (!content || !hasDesktop || !hasMobile || !form.link) {
        this.notify && this.notify("تصویر دسکتاپ، موبایل (فایل یا آدرس) و لینک الزامی است", "warning");
        return;
      }

      this.addingSlot = slot;
      const fd = new FormData();
      fd.append("banner_content", content.id);
      if (form.desktopFile) fd.append("desktop_image", form.desktopFile);
      if (form.desktopUrl) fd.append("desktop_image_external", form.desktopUrl);
      if (form.mobileFile) fd.append("mobile_image", form.mobileFile);
      if (form.mobileUrl) fd.append("mobile_image_external", form.mobileUrl);
      fd.append("link", form.link);
      fd.append("sort_order", form.sortOrder || 0);

      this.request({
        url: this.endpoint("cms/bannerContentItem"),
        method: "post",
        data: fd,
        headers: { "Content-Type": "multipart/form-data" },
        success: () => {
          this.addingSlot = null;
          this.resetItemForm(slot);
          this.fetchBannerContents();
        },
        error: () => {
          this.addingSlot = null;
          this.notify && this.notify("خطا در افزودن اسلاید", "danger");
        },
      });
    },
    deleteItem(slot, item) {
      this.request({
        url: this.endpoint(`cms/bannerContentItem/${item.id}`),
        method: "delete",
        success: () => {
          this.fetchBannerContents();
        },
      });
    },
  },
};
</script>
